export enum AuthStatusTypes {
    LOADING = "LOADING",
    UNAUTHENTICATED = "UNAUTHENTICATED",
    AUTHENTICATED = "AUTHENTICATED",
}
